module.exports = __webpack_public_path__ + "static/media/Ton.a8c45735.svg";